import { createFileRoute } from "@tanstack/react-router";
import TrapPage from "@/pages/TrapPage";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/trap-prices-feed/")({
  head: () => routeHead("/trap-prices-feed/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <TrapPage />
  );
}
